import React from "react";
import { useNavigate } from "react-router-dom";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

function Secret({ icon, percent, secret, searchParam }) {
  const navigate = useNavigate();

  return (
    <Card
      className="shake-head"
      elevation={0}
      sx={{
        background: "none",
        "&:hover": { cursor: "pointer" },
      }}
      onClick={() => navigate(`/diem-dac-biet?ddb=${searchParam}`)}
    >
      <CardContent>
        <Stack alignItems="center" width={250} spacing={2}>
          <img src={icon} alt={secret} width={200} />
          <Stack>
            <Typography variant="h4" color="info.main" align="center">
              {percent}
            </Typography>
            <Typography variant="h6" color="info.main" align="center">
              {secret}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

function WhyUs() {
  return (
    <Stack
      alignItems="center"
      spacing={4}
      pt={8}
      pb={8}
      sx={{ backgroundColor: "secondary.opaque" }}
    >
      <Typography variant="h2" color="info.main" align="center">
        Điểm đặc biệt
      </Typography>

      <Stack
        direction="row"
        justifyContent="center"
        useFlexGap
        flexWrap="wrap"
        spacing={4}
        maxWidth={1200}
      >
        <Secret
          icon="/images/recipe.png"
          percent="40%"
          secret="Công thức bí mật"
          searchParam="cong-thuc-bi-mat"
        />
        <Secret
          icon="/images/ingredient.png"
          percent="20%"
          secret="Nguyên liệu chất lượng"
          searchParam="nguyen-lieu-chat-luong"
        />
        <Secret
          icon="/images/expertise.png"
          percent="20%"
          secret="Chuyên gia tay nghề cao"
          searchParam="chuyen-gia-tay-nghe-cao"
        />
        <Secret
          icon="/images/presentation.png"
          percent="10%"
          secret="Trang trí hài hoà"
          searchParam="trang-tri-hai-hoa"
        />
        <Secret
          icon="/images/service.png"
          percent="10%"
          secret="Phục vụ chu đáo"
          searchParam="phuc-vu-chu-dao"
        />
      </Stack>
    </Stack>
  );
}

export default WhyUs;
